import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2 } from "lucide-react";
import { clearSignupFields, clearSignupImages } from "./signupState";

/**
 * Signup success screen. Ports the RN `RegisteredSuccessfullyScreen`:
 * confirmation + "EXPLORE NOW" which lands on the student home.
 * Wiping the staged signup state here keeps a second attempt in the same tab
 * from inheriting the finished account's images or dropdown selections.
 */
const SignupSuccessPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    clearSignupImages();
    clearSignupFields();
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-[#fff3e0] to-[#ffe0b2] p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-10 text-center shadow-xl">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#fff3e0] text-[#ffa217]">
          <CheckCircle2 size={44} />
        </span>
        <div className="mt-6 text-2xl font-extrabold text-[#333]">
          {t("REGISTERED SUCCESSFULLY")}
        </div>
        <p className="mt-2 text-sm text-gray-500">
          {t("Welcome to Uninfo HK. Your account is ready!")}
        </p>
        <button
          type="button"
          onClick={() => navigate("/student/home")}
          className="mt-8 w-full rounded-lg bg-[#ffa217] py-3 font-bold text-white transition hover:bg-[#e08f0e]"
        >
          {t("EXPLORE NOW")}
        </button>
      </div>
    </div>
  );
};

export default SignupSuccessPage;